// Copyright (c) Microsoft. All rights reserved.

import { /* Label, Link, */ Label, makeStyles, shorthands } from '@fluentui/react-components';
import { tokens } from '@fluentui/tokens';
import { SharedStyles } from '../../../styles';
import { Info16Regular } from '@fluentui/react-icons';

const useClasses = makeStyles({
    root: {
        ...shorthands.margin(tokens.spacingVerticalM, tokens.spacingHorizontalM),
        ...SharedStyles.scroll,
        display: 'flex',
        flexDirection: 'column',
    },
    wrapper: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        paddingBottom: '30px',
        paddingTop: '10px',
        '> svg': {
            width: '30px',
            marginRight: '10px',
        }
    },
    footer: {
        ...shorthands.flex(1, 0, 0),
    },
});

interface ITabViewProps {
    title: string;
    description?: string;
    children?: React.ReactNode;
}

export const TabView: React.FC<ITabViewProps> = ({ title, description, children }) => {
    const classes = useClasses();

    return (
        <div className={classes.root}>
            <h2>{title}</h2>
            {description && (
                <div className={classes.wrapper}>
                    <Info16Regular />
                    <Label size="medium" color="brand" className={classes.footer}>
                        {description}
                    </Label>
                </div>
            )}
            {children}
        </div>
    );
};
